'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESearchTopic = undefined;

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _isEmpty = require('ramda/src/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _core = require('@blueprintjs/core');

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledTopic = (0, _glamorous2.default)(_core.Card)({
  borderRadius: '0',
  height: '100%'
}, function (_ref) {
  var isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : 'ltr'
  };
});

var StyledTitle = _glamorous2.default.h5({
  color: _.Colors.BLUE1,
  fontSize: _.FontSizes.SIZE1
}, function (_ref2) {
  var hasSubtopics = _ref2.hasSubtopics;
  return {
    marginBottom: hasSubtopics ? null : 0
  };
});

var StyledSubTitles = _glamorous2.default.div({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap'
});

var StyledSubTitle = _glamorous2.default.span({
  color: _.Colors.GREY3,
  fontSize: _.FontSizes.SIZE3
}, function (_ref3) {
  var isRtl = _ref3.isRtl;
  return {
    paddingRight: isRtl ? 0 : 10,
    paddingLeft: isRtl ? 10 : 0
  };
});

var DESearchTopic = exports.DESearchTopic = function DESearchTopic(_ref4) {
  var id = _ref4.id,
      label = _ref4.label,
      subtopics = _ref4.subtopics,
      selectTopic = _ref4.selectTopic,
      isRtl = _ref4.isRtl;
  return _react2.default.createElement(
    StyledTopic,
    { onClick: selectTopic ? function () {
        return selectTopic(id);
      } : null, elevation: 2, interactive: true, isRtl: isRtl },
    _react2.default.createElement(
      StyledTitle,
      { hasSubtopics: !(0, _isEmpty2.default)(subtopics) },
      label
    ),
    _react2.default.createElement(
      StyledSubTitles,
      null,
      (0, _map2.default)(function (subtopic) {
        return _react2.default.createElement(
          StyledSubTitle,
          { key: subtopic, isRtl: isRtl },
          subtopic
        );
      })(subtopics)
    )
  );
};

DESearchTopic.propTypes = {
  id: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string,
  subtopics: _propTypes2.default.arrayOf(_propTypes2.default.string),
  selectTopic: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool
};

DESearchTopic.defaultProps = {
  subtopics: []
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-search-topic/index.js
// module id = 2024
// module chunks = 0